/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_developer_dash_accounts_status_creation_in_progress = /** @type {(inputs: {}) => string} */ () => {
	return `Creación en progreso`
};

const en_developer_dash_accounts_status_creation_in_progress = /** @type {(inputs: {}) => string} */ () => {
	return `Creation in progress`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const developer_dash_accounts_status_creation_in_progress = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.developer_dash_accounts_status_creation_in_progress(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("developer_dash_accounts_status_creation_in_progress", locale)
	if (locale === "es") return es_developer_dash_accounts_status_creation_in_progress(inputs)
	return en_developer_dash_accounts_status_creation_in_progress(inputs)
};
export { developer_dash_accounts_status_creation_in_progress as "developer.dash_accounts.status.creation_in_progress" }